import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FlexLeftCenter } from "../../constant/CustomeStyle";

const menuInfo = [
  { title: "Work Period Report", to: "/work-period-report" },
  { title: "Waiter Cashier Report", to: "/work-period-report" },
  { title: "Work Period Sales Summart Report", to: "/work-period-report" },
  { title: "Sales Summary Report(Tax)", to: "/work-period-report" },
  { title: "Sales Summary Report", to: "/work-period-report" },
  { title: "Work Period Report to Print", to: "/work-period-report" },
  {
    title: "Department(Ticket) Wiase Sales Details Report",
    to: "/work-period-report",
  },
  { title: "Item Sales Report to Print", to: "/work-period-report" },
  { title: "Item Sales Report", to: "/work-period-report" },
  { title: "Inventory Purches Report", to: "/work-period-report" },
  { title: "Inventory Report", to: "/work-period-report" },
  { title: "Cost Report", to: "/work-period-report" },
  { title: "NBR X Report", to: "/work-period-report" },
  { title: "NBR Z Report", to: "/work-period-report" },
];

const LeftMenu = () => {
  const navigate = useNavigate();
  const [selectedIdx, setSelectedIdx] = useState(0);

  const handleMenu = (idx, to) => {
    setSelectedIdx(idx);
    navigate(to);
  };

  return (
    <div>
      {menuInfo.map((item, index) => (
        <MenuBox
          handleMenu={handleMenu}
          info={item}
          key={index}
          idx={index}
          selectedIdx={selectedIdx}
        />
      ))}
    </div>
  );
};

const MenuBox = ({ handleMenu, info, idx, selectedIdx }) => (
  <FlexLeftCenter
    style={{
      width: 178,
      height: 46,
      background: "#333C4B",
      marginTop: 2,
      cursor: "pointer",
      borderLeft: `3px solid ${selectedIdx == idx ? "#ED1B24" : "#333C4B"}`,
    }}
    onClick={() => handleMenu(idx, info.to)}
  >
    <div
      style={{
        marginTop: 7,
        fontSize: 12,
        color: "#FFFFFF",
        padding: "0 5px",
        fontWeight: "500",
        fontFamily: `Poppins, sans-serif`,
        textAlign: "left",
      }}
    >
      {info.title}
    </div>
  </FlexLeftCenter>
);

export default LeftMenu;
